var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 568",
    style: {
      fill: "none",
      opacity: 0.509
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 469"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 161",
    d: "M271.574-1279.865a2.582 2.582 0 0 0-2.034 1.438 2.539 2.539 0 0 0 .031 2.286 2.557 2.557 0 0 0 3.385 1.132 2.569 2.569 0 0 0 1.415-1.922 3.406 3.406 0 0 0 0-.759 2.552 2.552 0 0 0-.65-1.363 2.581 2.581 0 0 0-2.147-.812z",
    transform: "translate(-261.455 1280.878)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 162",
    d: "M4.68-889.65a1.352 1.352 0 0 0-.6.275c-.047.038-.9.887-1.906 1.887-1.3 1.3-1.835 1.843-1.876 1.905a.824.824 0 0 0 .089 1.075.792.792 0 0 0 .348.215.935.935 0 0 0 .675-.057c.165-.084.257-.171 1.317-1.234l1.089-1.093v1.962h5.412v-1.964l1.141 1.136a12.291 12.291 0 0 0 1.237 1.187.834.834 0 0 0 .413.113.79.79 0 0 0 .4-.092.957.957 0 0 0 .371-.329.831.831 0 0 0-.051-.952c-.078-.1-3.645-3.67-3.747-3.748a1.486 1.486 0 0 0-.554-.271 12.084 12.084 0 0 0-1.882-.033c-1.461-.002-1.785.001-1.876.018z",
    transform: "translate(3.859 896.216)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 163",
    d: "M112.9-467.091c-.5.5-.928.939-.95.974a1.466 1.466 0 0 0-.143.276 1.557 1.557 0 0 0-.024.894 2.011 2.011 0 0 0 .273.572c.079.1 2.5 2.636 2.64 2.756a1.175 1.175 0 0 0 .443.225.824.824 0 0 0 .78-.241.849.849 0 0 0 .27-.574.907.907 0 0 0-.222-.642 32.253 32.253 0 0 0-.848-.867l-.766-.765.746-.746.748-.748-1.013-1.013c-.557-.557-1.015-1.013-1.02-1.013s-.414.412-.914.912z",
    transform: "translate(-106.151 480.551)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 164",
    d: "m472.49-466.987-1.013 1.013.746.746.748.748-.833.836c-.888.892-.9.908-.969 1.112a1.088 1.088 0 0 0-.026.443.947.947 0 0 0 .486.629.887.887 0 0 0 .936-.112c.1-.072 2.594-2.66 2.7-2.794a1.661 1.661 0 0 0 .323-1.061 1.194 1.194 0 0 0-.176-.622 8.61 8.61 0 0 0-.98-1.034c-.5-.5-.916-.916-.922-.916s-.464.455-1.02 1.012z",
    transform: "translate(-460.426 480.551)",
    style: {
      fill: "#939393"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/child.523f9eae258c193962fda169f77e1b05.svg";
export { ForwardRef as ReactComponent };